import { useTranslation } from 'react-i18next';
import { Paperclip } from 'lucide-react';
import type { MessageSummary } from '../../../shared/api/types';
import { formatMessageTime } from '../../../shared/lib/format';
import { Checkbox } from '../../../shared/ui/Checkbox';

export function MessageRow({
  message,
  onOpen,
  selectable = false,
  selected = false,
  onToggle,
}: {
  message: MessageSummary;
  onOpen: (id: string) => void;
  /** Режим выбора (promt-74 §7f): вместо перехода — чекбокс. */
  selectable?: boolean;
  selected?: boolean;
  onToggle?: (id: string, checked: boolean) => void;
}) {
  const { t } = useTranslation();
  const sender = message.fromName ?? message.fromAddress;

  const body = (
    <div className={`min-w-0 flex-1 ${message.isRead || selectable ? 'pl-5' : ''}`}>
      <div className="flex items-baseline justify-between gap-3">
        <span className={`truncate ${message.isRead ? 'text-fg' : 'font-semibold text-fg'}`}>
          {sender}
        </span>
        <span className="shrink-0 text-xs text-fg-muted">{formatMessageTime(message.receivedAt)}</span>
      </div>
      <div className={`mt-0.5 truncate text-sm ${message.isRead ? 'text-fg-muted' : 'text-fg'}`}>
        {message.subject ?? t('message.detail.noSubject')}
      </div>
      {message.attachmentCount > 0 && (
        <span className="mt-2 inline-flex items-center gap-1.5 rounded-md bg-success-soft px-2 py-1 text-xs text-success-text">
          <Paperclip className="h-3.5 w-3.5" />
          {t('message.attachments', { count: message.attachmentCount })}
        </span>
      )}
    </div>
  );

  if (selectable) {
    return (
      <label className="flex w-full cursor-pointer items-start gap-3 border-b border-border px-5 py-4 text-left last:border-b-0 hover:bg-page/60">
        <Checkbox
          checked={selected}
          onCheckedChange={(v) => onToggle?.(message.id, v)}
          aria-label={message.subject ?? sender}
          className="mt-0.5"
        />
        {body}
      </label>
    );
  }

  return (
    <button
      type="button"
      onClick={() => { onOpen(message.id); }}
      className="flex w-full items-start gap-3 border-b border-border px-5 py-4 text-left last:border-b-0 hover:bg-page/60"
    >
      {!message.isRead && <span className="mt-2 h-2 w-2 shrink-0 rounded-full bg-brand" aria-label="непрочитано" />}
      {body}
    </button>
  );
}
